module.exports = __webpack_public_path__ + "img/cup_res.0d071212.svg";